<template>
    <Loading v-bind:show="showLoading">
        <PageTitle title="Chamados" />
        <div v-if="!showLoading">
            <div class="md-layout-item md-size-100">
                <Grid v-bind:Data="dadosAba.chamados"
                      v-bind:Header="header"
                      Name="SituacaoAcademica"
                      Title="Total"
                      OrderBy="CreatedAt"
                      v-bind:HeaderDetalhes="null"
                      v-bind:DetalhesCombo1="dadosAba.situacao"
                      v-bind:DetalhesCombo2="null"
                      v-bind:DetalhesCombo3="null" v-if="$featureToggle && $featureToggle.INTEGRA_CHAMADOS_GRID" />
            </div>
        </div>
    </Loading>
</template>
<script>
    import Grid from '@/components/Grid';
    import Chamado from '@/services/ChamadoService.js';
    import Loading from '@/components/Loading';
    import PageTitle from '@/components/PageTitle';

  export default {
    components: {
        Grid,
        Loading,
        PageTitle
    },
    created() {
      if (this.$featureToggle.INTEGRA_CHAMADOS_GRID) {

        this.chamadoService = new Chamado(this);

        //Verifica se tem aluno selecionado
        if (!sessionStorage.Aluno) {
          this.$router.push('home');
        }
        else {
          let a = JSON.parse(sessionStorage.Aluno);
          //Coloca o perfil de aluno disponível na variável aluno
          if (a.PerfilAluno) {
            this.aluno = a.PerfilAluno;

            //Verifica se a aba ja está carregada
            if (a.Chamado) {
              this.dadosAba = a.Chamado;
            }
            else {
              //Popula os dados da aba
              this.showLoading = true;
              this.chamadoService.ObterChamadosDoAluno({
                CodigoAluno: this.aluno.codigoAluno,
                CodigoEspecialidade: this.aluno.codigoEspecialidade
              }).then(
                data => {
                  if (data.ok) {
                    this.dadosAba = data.dados;
                  }
                  else {
                    this.$modal.info(data.Mensagem);
                  }
                },
                error => {
                  if (error.status != 500)
                    this.$modal.alert((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                  else
                    this.$modal.error((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                }).finally(() => {
                  this.showLoading = false;
                });
            }
          }
          else
            this.$router.push('home');
        }
      }
      else {
        this.$modal.alert(this.$msgFeatureToggle);
      }
    },
    beforeDestroy() {
      let aluno = JSON.parse(sessionStorage.Aluno);

      //Armazena os dados da aba pra nao precisar carregar novamente
      aluno.Chamado = this.dadosAba;
      sessionStorage.setItem("Aluno", JSON.stringify(aluno));
    },
    data() {
      return {
        aluno: null,
        showLoading: false,
        header: [
          {
            Titulo: "Chamado",
            Field: "number",
            Width: "80px",
            Tipo: "texto"
          },
          {
            Titulo: "Canal",
            Field: "contactType",
            Width: "40px",
            Tipo: "texto"
          },
          {
            Titulo: "Nome do Filtro",
            Field: "short_description",
            Width: "400px",
            Tipo: "texto"
          },
          {
            Titulo: "Data Abertura",
            Field: "sys_created_on",
            Width: "80px",
            Tipo: "dataTime"
          },
          {
            Titulo: "Data Alteração",
            Field: "sys_updated_on",
            Width: "80px",
            Tipo: "dataTime"
          },
          {
            Titulo: "Situação",
            Field: "situacaoChamado",
            Width: "200px",
            Tipo: "texto"
          },
          {
            Titulo: "Link",
            Field: "linkServiceNow",
            Width: "80px",
            Tipo: "texto"
          }
        ],

        dadosAba: null
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .md-field {
    max-width: 100%;
    font-weight: bold;
  }
</style>
